<template>
  <Page title="Welcome to Cognni" subtitle="Please provide your consent">
    <div class="w-full flex flex-col items-center justify-center">
      <Agreement v-model="agree" />
      <AppButton
        :disable="!agree || isLoading"
        text="MS SSO consent"
        class="bg-primary"
        @click="redirectToMs"
      />
    </div>
  </Page>
</template>

<script>
import Page from "@/components/Page.vue";
import Agreement from "@/components/Agreement.vue";
import axios from "axios";
import { getQueryParams } from "../utils";
export default {
  components: {
    Page,
    Agreement
  },
  data() {
    return {
      agree: false,
      isLoading: false
    };
  },
  mounted() {
    const qparams = getQueryParams(location.search);
    if (qparams.code) {
      this.auth(qparams.code);
    }
    if (qparams.error) {
      this.concentError = true;
    }
  },
  methods: {
    async redirectToMs() {
      if (this.isLoading) {
        return;
      }
    },
    async auth(code) {
      try {
        this.isLoading = true;
        const res = await axios.post("/ms-graph", { code });
        const { token } = res.data;
        this.$router.push({ name: "global-admin" });
      } catch (e) {
        console.log("ConcentView auth() , error: ", e);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
